import * as React from 'react';
function DownloadOutlineIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.707 11.707a1 1 0 00-1.414-1.414L13 12.586V5a1 1 0 10-2 0v7.586l-2.293-2.293a1 1 0 10-1.414 1.414L12 16.414l4.707-4.707zM5 18a1 1 0 100 2h14a1 1 0 100-2H5z",
    fill: "currentColor"
  }));
}
export default DownloadOutlineIcon;